import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const calendarControls = css`
  display: flex;
  button:focus,
  button:hover {
    outline: none;

    svg {
      color: ${theme.colors.neutral90};
      transition: color ease-in 300ms;
    }
  }
`;

export const controlsHeader = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing(0, 0.5, 2, 2)};
`;

export const monthName = css`
  color: ${theme.colors.neutral90};
  font-size: ${theme.fontSize(20)};
  font-weight: ${theme.font.weight.bold};
  margin: 0;
`;

export const SingleMonthCalendarControlStyles = {
  calendarControls: calendarControls,
  controlsHeader: controlsHeader,
  monthName: monthName,
};
